import { getStoreService } from '../../services/ServiceHandler';
import { actionSetStores } from './storesActions';

export const thunkFetchStores = () => async dispatch => {
  try {
    const stores = await getStoreService().getStores();
    dispatch(actionSetStores(stores));
  } catch (error) {
    console.warn('StoreService failed to fetch stores');
    console.error(error);
  }
};
